module.exports = __webpack_public_path__ + "img/26_7.644f2539.png";